export default function Input({ type, defaultName, setName, placeHolder,filename }) {
  return (
   
      <input
      
        multiple
        type={type}
        className={type === "file" ? "profilePic col-sm-12" : "form-control"}
        id="val-confirm-password"
        name="val-confirm-password"
        value={defaultName}
        placeholder={placeHolder}
        onChange={(e) => {
          if (type === "file") {
            filename=e.target.files[0].name
            const reader = new FileReader();
            reader.addEventListener("load", () => {
              setName(reader.result);
            });
            reader.readAsDataURL(e.target.files[0]);
          } else {
            setName(e.target.value);
          }
        }}
      />
   
  );
}
